var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"main"},[_c('img',{staticClass:"img",attrs:{"src":require("../assets/images/empty.png"),"alt":"unlucky"}}),_c('div',{staticClass:"text"},[_vm._v("您的账号异常，暂时无法参与活动")])])
}]

export { render, staticRenderFns }